import React, { useContext } from 'react';
import AuthContext from 'context/AuthContext';
import TabPreviewMapTravelLeaflet from './TabPreviewMapTravelLeaflet';
import TabPreviewMapTravelAzure from './TabPreviewMapTravelAzure';

const TabPreviewMapTravel = (props) => {
    const { panel } = useContext(AuthContext);
    const provider = props.provider || panel?.map_type || panel?.map_provider || 'lf';

    switch (provider) {
        case 'az':
            return <TabPreviewMapTravelAzure {...props} />;
        case 'lf':
        default:
            return <TabPreviewMapTravelLeaflet {...props} />;
    }
};

export default TabPreviewMapTravel;
